export default function DeliverableSection({ title, icon, image, imageAlt, lead, body, points, reverse }) {
  return (
    <article className={`net-infra-deliverable${reverse ? ' net-infra-deliverable-reverse' : ''}`}>
      <div className="net-infra-deliverable-image-wrap">
        <img src={image} alt={imageAlt} className="net-infra-deliverable-image" />
      </div>
      <div className="net-infra-deliverable-content">
        <div className="net-infra-deliverable-header">
          <div className="net-infra-deliverable-title-row">
            <span className="net-infra-deliverable-icon" aria-hidden="true">
              <i className={icon} />
            </span>
            <h3 className="net-infra-deliverable-title">{title}</h3>
          </div>
          <p className="net-infra-deliverable-lead">{lead}</p>
        </div>
        <ul className="net-infra-deliverable-list">
          {points.map((point) => (
            <li key={point}>{point}</li>
          ))}
        </ul>
        <p className="net-infra-deliverable-body">{body}</p>
      </div>
    </article>
  );
}
